import { render, staticRenderFns } from "./EditFileChoicer.vue?vue&type=template&id=4f312c15&scoped=true"
import script from "./EditFileChoicer.vue?vue&type=script&lang=ts"
export * from "./EditFileChoicer.vue?vue&type=script&lang=ts"
import style0 from "./EditFileChoicer.vue?vue&type=style&index=0&id=4f312c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f312c15",
  null
  
)

export default component.exports